import Image from 'next/image';

import { IResolvedCardItem } from '@/src/utils/collections/cards.mapper';
import { CardAction } from '@/src/components/cards/CardAction/CardAction';
import { ILocaleType } from '@/src/types';
import { IZoneWithDestinationsAndPromo } from '@/src/modules/destinations/destinations.modules';
import { CardContent } from '@/src/components/cards/CardContent/CardContent';

interface IProps {
  item: IResolvedCardItem;
  destinations?: Record<string, IZoneWithDestinationsAndPromo>;
  locale: ILocaleType;
}

export const CardOneColumn = ({ item, locale, destinations }: IProps) => {
  return (
    <div
      className={
        'mx-3 flex max-w-1200 flex-col justify-between rounded-3xl bg-primary py-18 lg:mx-auto lg:min-h-[320px] lg:flex-row'
      }
    >
      <div className={'relative flex h-[350px] lg:mt-0 lg:h-0 lg:w-[520px]'}>
        {item.media.type === 'image' && item.media.data && (
          <Image
            className={
              'absolute left-[-30px] top-[-25px] lg:left-[50px] lg:top-[-125px]'
            }
            placeholder={'blur'}
            blurDataURL={'/static/images/placeholder.webp'}
            width={430}
            height={430}
            src={item.media.data.image}
            alt={item.media.data.alt || ''}
          />
        )}
        {item.media.type === 'icon' && item.media.data && (
          <Image
            width={64}
            height={64}
            src={item.media.data.icon}
            alt={item.media.data.alt || ''}
          />
        )}
      </div>
      <div className={'flex-1 px-6 tracking-[-1px]'}>
        <div className={'text-4xl font-bold'}>{item.title}</div>
        <CardContent cardContent={item.content} />
        <CardAction
          destinations={destinations}
          action={item.action}
          locale={locale}
        />
      </div>
    </div>
  );
};
